import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StringTransformHelper } from '../../../shared/string-transform.helper';
import { LiveClassDto } from '../../../shared/types/LiveClassDto';

@Component({
  selector: 'lp2-live-class-type',
  templateUrl: './live-class-type.component.html',
  styleUrls: ['./live-class-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LiveClassTypeComponent {
  @Input() public set subType(subtype: LiveClassDto['subType']) {
    const camelCaseSubType = StringTransformHelper.toCamelCase(subtype);
    this.classTypeKey = `studybundle.liveClasses.${camelCaseSubType}`;
    this.tooltipKey = `studybundle.liveClasses.${camelCaseSubType}Tooltip`;
  };

  public classTypeKey: string;
  public tooltipKey: string;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-tile/live-class-type/live-class-type.component.ts